"use strict";
import { ContextualHelpMarkup } from "./";
export const Template = ContextualHelpMarkup;
//# sourceMappingURL=template.js.map
